import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

function VenueList() {
    const [venues, setVenues] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');

    useEffect(() => {
        axios.get(`${config.API_URL}/venues`)
            .then(res => {
                setVenues(res.data);
                setLoading(false);
            })
            .catch(err => {
                setError('Failed to load venues');
                setLoading(false);
            });
    }, []);

    const filtered = venues.filter(v =>
        v.name.toLowerCase().includes(search.toLowerCase()) ||
        (v.city && v.city.toLowerCase().includes(search.toLowerCase())) ||
        (v.state && v.state.toLowerCase().includes(search.toLowerCase()))
    );

    if (loading) return <div style={styles.message}>Loading venues...</div>;
    if (error) return <div style={styles.error}>{error}</div>;

    return (
        <div>
            <div style={styles.header}>
                <h1 style={styles.title}>Venues</h1>
                <Link to="/add-venue" style={styles.addButton}>+ Add Venue</Link>
            </div>

            <input
                type="text"
                placeholder="Search venues by name or location..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={styles.search}
            />

            {filtered.length === 0 ? (
                <div style={styles.message}>
                    {venues.length === 0 ? 'No venues yet. Add your first venue!' : 'No venues match your search.'}
                </div>
            ) : (
                <div style={styles.grid}>
                    {filtered.map(venue => (
                        <Link to={`/venues/${venue.slug || venue.id}`} key={venue.id} style={styles.card}>
                            <div style={styles.cardName}>{venue.name}</div>
                            <div style={styles.cardLocation}>
                                {[venue.city, venue.state, venue.country].filter(Boolean).join(', ')}
                            </div>
                            <div style={styles.cardMeta}>
                                {venue.venue_type && <span style={styles.tag}>{venue.venue_type}</span>}
                                {venue.age_limit && <span style={styles.tag}>{venue.age_limit}</span>}
                                {venue.capacity && <span style={styles.tag}>Cap: {venue.capacity}</span>}
                            </div>
                            <div style={styles.cardStatus}>
                                <span style={{
                                    ...styles.statusDot,
                                    backgroundColor: venue.status === 'Open' ? '#03dac6' : venue.status === 'Closed' ? '#cf6679' : '#ffb74d'
                                }} />
                                {venue.status}
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}

const styles = {
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    title: {
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#e0e0e0',
    },
    addButton: {
        backgroundColor: '#bb86fc',
        color: '#121212',
        textDecoration: 'none',
        padding: '8px 16px',
        borderRadius: '4px',
        fontWeight: 'bold',
        fontSize: '14px',
    },
    search: {
        backgroundColor: '#2c2c2c',
        border: '1px solid #444',
        borderRadius: '8px',
        padding: '12px 16px',
        fontSize: '15px',
        color: '#e0e0e0',
        width: '100%',
        marginBottom: '24px',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '16px',
    },
    card: {
        backgroundColor: '#1e1e1e',
        border: '1px solid #333',
        borderRadius: '8px',
        padding: '20px',
        textDecoration: 'none',
        color: '#e0e0e0',
        display: 'block',
    },
    cardName: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '6px',
        color: '#e0e0e0',
    },
    cardLocation: {
        fontSize: '14px',
        color: '#aaa',
        marginBottom: '12px',
    },
    cardMeta: {
        display: 'flex',
        gap: '8px',
        flexWrap: 'wrap',
        marginBottom: '12px',
    },
    tag: {
        backgroundColor: '#2c2c2c',
        border: '1px solid #444',
        borderRadius: '4px',
        padding: '2px 8px',
        fontSize: '12px',
        color: '#bb86fc',
    },
    cardStatus: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        fontSize: '13px',
        color: '#aaa',
    },
    statusDot: {
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        display: 'inline-block',
    },
    message: {
        textAlign: 'center',
        color: '#aaa',
        fontSize: '16px',
        padding: '60px 0',
    },
    error: {
        textAlign: 'center',
        color: '#cf6679',
        fontSize: '16px',
        padding: '60px 0',
    },
};

export default VenueList;